// ==========================================================================
// Load an external script
// ==========================================================================
import loadjs from'loadjs';export default function loadScript(url){return new Promise(function(resolve,reject){loadjs(url,{success:resolve,error:reject});});}